import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { TableRow } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const ProviderRisksPageHeader: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <TableRow>
      <TableHeaderCell label={formatMessage({ id: 'riskScreening.providerRisksPage.headers.esgArea' })} />
      <TableHeaderCell label={formatMessage({ id: 'riskScreening.providerRisksPage.headers.riskIndex' })} />
      <TableHeaderCell label={formatMessage({ id: 'riskScreening.providerRisksPage.headers.severity' })} />
      <TableHeaderCell label={formatMessage({ id: 'riskScreening.providerRisksPage.headers.context' })} />
    </TableRow>
  )
}

export default ProviderRisksPageHeader
